/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const skippedCandidateDataReasonSchema = z.enum(['no_phone', 'opted_out', 'missing_parameter_data'])

export type SkippedCandidateDataReasonSchema = z.infer<typeof skippedCandidateDataReasonSchema>
